import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AdminProvider } from '../context/AdminContext';
import { AuthProvider } from '../context/AuthContext';
import { AvatarProvider } from '../context/AvatarContext';
import { CourseEditingProvider } from '../context/CourseEditingContext';
import { LessonProvider } from '../context/LessonContext';
import { SidebarProvider } from '../context/SidebarContext';
import { StudentProvider } from '@/data/context/_deprecated/StudentContext';
import { PropsWithChildren, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { ConfigProvider } from '../context/ConfigContext';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import TreeProvider from '../context/TreeContext';
import { ChatBotProvider } from '../context/ChatBotContext';
import { ConfirmModalProvider } from '../context/ConfirmModalContext';
import { PyodideProvider } from '../context/PyodideContext';
import PromptTreeProvider from '../context/PromptTreeContext';
import { TreeCoursesProvider } from '../context/TreeCoursesContext';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { growthbook } from '@/lib/growthbook';
import GrowthBookSetUserAttributes from './GrowthBookSetUserAttributes';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export default function Providers({ children }: PropsWithChildren) {
  useEffect(() => {
    growthbook.init({ streaming: true });
  }, []);

  return (
    <QueryClientProvider client={client}>
      <ReactQueryDevtools
        initialIsOpen={false}
        position="top-left"
        toggleButtonProps={{ className: 'z-10' }}
      />
      <HelmetProvider>
        <ConfigProvider>
          <GrowthBookProvider growthbook={growthbook}>
            <AuthProvider>
              <GrowthBookSetUserAttributes>
                <SidebarProvider>
                  <AvatarProvider>
                    <PyodideProvider>
                      <StudentProvider>
                        <LessonProvider>
                          <AdminProvider>
                            <TreeProvider>
                              <TreeCoursesProvider>
                                <PromptTreeProvider>
                                  <CourseEditingProvider>
                                    <ChatBotProvider>
                                      <ConfirmModalProvider>
                                        {children}
                                      </ConfirmModalProvider>
                                    </ChatBotProvider>
                                  </CourseEditingProvider>
                                </PromptTreeProvider>
                              </TreeCoursesProvider>
                            </TreeProvider>
                          </AdminProvider>
                        </LessonProvider>
                      </StudentProvider>
                    </PyodideProvider>
                  </AvatarProvider>
                </SidebarProvider>
              </GrowthBookSetUserAttributes>
            </AuthProvider>
          </GrowthBookProvider>
        </ConfigProvider>
      </HelmetProvider>
    </QueryClientProvider>
  );
}
